// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/enterprise/partner/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const enterprisePartnerEN: PageEntry = {
  id: "post.unternehmen-unsere-partner-und-mitgliedschaften",
  locale: "en",
  slug: "enterprise/partner",
  seo: {
    navLabel: "Partners",
    title: "Partner of Dietz Federn",
    description: "Partner of Dietz Federn",
  },
  type: "post",
  h1: "Partner of Dietz Federn",
  blocks: [
    { kind: "image", src: "/images/live/dietz_aussen-1200x375.jpg", alt: "Partner of Dietz Federn", width: 1200, height: 375 },
    { kind: "heading", level: 2, text: "Our Partners and Memberships" },
    { kind: "paragraph", text: "Our partners make a significant contribution to the high quality of our products and services:" },
    { kind: "paragraph", text: "Steinbeis Transfer Center for Spring Technology Faculty of Mechanical Engineering" },
    { kind: "logos", items: [
      { src: "/images/partners/TU-IL.png", alt: "Ilmenau University of Technology FG Machine Elements", href: "https://www.tu-ilmenau.de/maschinenelemente/" },
      { src: "/images/partners/Hochschule-Kempten.jpg", alt: "Kempten University of Applied Sciences with the Allgäu Research Centre", href: "http://www.hochschule-kempten.de/home.html" },
      { src: "/images/partners/Steinbeis_01_9e1e371907.jpg", alt: "Steinbeis Transfer Center for Spring Technology", href: "https://www.steinbeis.de/de.html" },
      { src: "/images/partners/IFU.jpg", alt: "Institute of Forming Technology Lüdenscheid", href: "http://www.ifu-lued.de/" },
      { src: "/images/partners/2022-03-03-logo-klimaschutz-unternehmen-data-300x200.jpg", alt: "Klimaschutz-Unternehmen e.V.", href: "https://www.klimaschutz-unternehmen.de/startseite/" },
      { src: "/images/partners/VDFI.jpg", alt: "Association of the German Spring Industry", href: "https://federnverband.de/" },
      { src: "/images/partners/knf-logo-neu-rgb.jpg", alt: "The specialist network of the plastics industry", href: "https://www.kunststoff-netzwerk-franken.de/" },
      { src: "/images/partners/ofracar.jpg", alt: "OfraCar - Automobile Network e. V.", href: "http://www.ofracar.de/" },
      { src: "/images/partners/unk-gruendungsmitglied-220117-1.png", alt: "Corporate Network Climate Protection", href: "http://unternehmensnetzwerk-klimaschutz.de/" },
      { src: "/images/partners/Mitglieder-Logo.png", alt: "VEA Initiative for Climate-Friendly SMEs", href: "https://www.klimafreundlicher-mittelstand.de/" },
      { src: "/images/partners/csm_IHK_Logo_1551352070_ba4338695a-300x211.jpg", alt: "IHK zu Coburg", href: "https://www.ihk.de/coburg/" },
    ] },
  ],
};
